export const makeAsyncIterable = <T>(result: T): AsyncIterable<T> => {
  return (async function* () {
    yield result;
  })();
}
